<template>
  <v-layout
    v-if="user"
    column
    align-center
    style="flex-grow: 0"
  >
    <v-layout column>
      <!-- Note: Query param is for cache busting in Chrome, to ensure the
      img src updates when new data arrives.-->
      <user-avatar-image
        v-if="user.clientprofile.avatar_image_url"
        :user="user"
        class="mb-2"
      />
      <v-icon
        v-else
        style="font-size: 64px"
      >
        person
      </v-icon>
      <button
        id="pick-avatar"
        class="anchor nowrap"
        :class="{'grey--text': user.clientprofile.avatar_image_url}"
      >
        {{ $t('uploadUserAvatar') }}
      </button>
    </v-layout>
    <avatar-cropper
      trigger="#pick-avatar"
      :upload-url="uploadUserAvatarUrl"
      :labels="{submit: $t('submit'), cancel: $t('cancel')}"
      @uploaded="() => $emit('uploaded')"
    />
  </v-layout>
</template>

<script>
import AvatarCropper from 'vue-avatar-cropper';

import environment from '@/environment';

import UserAvatarImage from '@/components/UserAvatarImage';

export default {
  name: 'UserAvatarImageUpload',
  components: {
    AvatarCropper,
    UserAvatarImage,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
    uploadUserAvatarUrl() {
      return environment.urls.api + 'account/user/avatar';
    },
  },
};
</script>

<style>
.avatar-cropper-btn:hover {
  background-color: var(--msr-color-primary) !important;
}
</style>

<style scoped>
.anchor {
  color: var(--msr-color-primary);
  text-decoration: underline;
  pointer-events: initial;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/UserAvatarImageUpload.vue